export default "__VITE_ASSET__C62vdD2v__"